var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('popup-base',{attrs:{"row":_vm.row},on:{"update-popup-size":function($event){return _vm.$emit('update-popup-size')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }